import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { useAuth } from '../../contexts/AuthContext'
import imgLogo1 from '../../assets/c08caa95c3af571c428be5aff42e92e432726d09.png'
import './styles.css'

// Importar iconos SVG desde assets/icons
import iconPanelDatos from '../../assets/icons/graph.svg'
import iconLogs from '../../assets/icons/logs.svg'
import iconVisor from '../../assets/icons/map.svg'
import iconIA from '../../assets/icons/ai.svg'
import iconDoc from '../../assets/icons/documents.svg'
import iconAyuda from '../../assets/icons/help.svg'

function Sidebar({ isOpen, onClose }) {
  const location = useLocation()
  const navigate = useNavigate()
  const { user, permissions, logout } = useAuth() || {}

  // Cerrar sidebar al hacer clic en un enlace en móvil
  const handleLinkClick = () => {
    if (window.innerWidth <= 1024) {
      onClose?.()
    }
  }

  // Cerrar sidebar con tecla Escape
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isOpen) {
        onClose?.()
      }
    }

    document.addEventListener('keydown', handleEscape)
    return () => document.removeEventListener('keydown', handleEscape)
  }, [isOpen, onClose])

  const menuItems = [
    { path: '/general', label: 'Panel de Datos', icon: iconPanelDatos },
    { path: '/logs', label: 'Logs', icon: iconLogs },
    { path: '/visor', label: 'Visor', icon: iconVisor },
    { path: '/ia', label: 'Análisis con IA', icon: iconIA },
    { path: '/documentacion', label: 'Documentación', icon: iconDoc }
  ]

  // Filtrar items según los permisos del usuario
  const filteredMenuItems = menuItems.filter((item) => {
    if (item.path === '/logs' && !permissions?.canViewLogs) return false
    if (item.path === '/visor' && !permissions?.canViewVisor) return false
    if (item.path === '/ia' && !permissions?.canViewIA) return false
    if (item.path === '/documentacion' && !permissions?.canViewDocs) return false
    return true
  })

  // Determinar si un item está activo
  const isActive = (path) => {
    if (path === '/general') {
      // Panel de Datos está activo en /general, /usuarios, /autorizaciones, /cupos, /capturas, /capturas/:especie y /
      return location.pathname === '/general' ||
             location.pathname === '/' ||
             location.pathname === '/usuarios' ||
             location.pathname === '/autorizaciones' ||
             location.pathname === '/cupos' ||
             location.pathname === '/capturas' ||
             location.pathname.startsWith('/capturas/')
    }
    return location.pathname === path
  }

  const handleLogout = async () => {
    if (confirm('¿Estás seguro de que deseas cerrar sesión?')) {
      await logout()
      navigate('/login')
    }
  }

  return (
    <aside className={`sidebar ${isOpen ? 'sidebar--open' : ''}`}>
      <div className="sidebar-header">
        {/* <h2 className="sidebar-title">Métricas</h2> */}
        <div className="sidebar-logo">
          <img src={imgLogo1} alt="Logo" className="logo-img" />
        </div>
      </div>

      {/* {user && (
        <div className="sidebar-user">
          <div className="sidebar-user-info">
            <span className="sidebar-user-email">{user.email}</span>
          </div>
        </div>
      )} */}

      <nav className="sidebar-nav">
        <div className="sidebar-nav-main">
          {filteredMenuItems.filter(item => item.path !== '/ayuda').map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`sidebar-link ${isActive(item.path) ? 'sidebar-link--active' : ''}`}
              onClick={handleLinkClick}
            >
              <img src={item.icon} alt="" className="sidebar-icon" />
              <span>{item.label}</span>
            </Link>
          ))}
        </div>
        <div className="sidebar-nav-divider"></div>
        <div className="sidebar-nav-footer">
          <a
            href="https://www.capturascotos.app/"
            target="_blank"
            rel="noopener noreferrer"
            className="sidebar-link"
            onClick={handleLinkClick}
          >
            <img src={iconAyuda} alt="" className="sidebar-icon" />
            <span>Ayuda</span>
          </a>

          <button
            onClick={handleLogout}
            className="sidebar-link sidebar-logout"
          >
            <svg className="sidebar-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
              <polyline points="16,17 21,12 16,7"/>
              <line x1="21" y1="12" x2="9" y2="12"/>
            </svg>
            <span>Cerrar Sesión</span>
          </button>
        </div>
      </nav>
      <div className="sidebar-footer">
        <p className="sidebar-support">
          Si necesitas soporte contacta con:
        </p>
        <p className="sidebar-support">
          <span className="sidebar-support-email">soporte@capturascotos.app</span>
        </p>
      </div>
    </aside>
  )
}

export default Sidebar
